// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import { change } from 'redux-form'

const handleAntennaFieldToggle = (event, sourceForm) => (dispatch, getState) => {
  const { value } = event.target

  const {
    antennaCode,
    antennaCompanyId,
  } = getState().form [sourceForm].initial

  //
  dispatch(change(sourceForm, 'antennaField', value))
  dispatch(change(sourceForm, 'antennaCode', antennaCode))
  dispatch(change(sourceForm, 'antennaCompanyId', antennaCompanyId))
}

export default handleAntennaFieldToggle